module.exports = __webpack_public_path__ + "img/parrallel_2.4e81b363.png";